import React, {useEffect, useState} from 'react';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Time from 'react-time-format';
import {NotificationManager} from 'react-notifications';
import Title from '../dashboard/Title';
import ConfirmDialog from './ConfirmDialog';
import UserService from '../../services/user.service';
import {logOut} from '../../helpers/logout';
import {useDashboardStyles} from '../settings/dashboardStyles';

export default function TrashBin(props) {
    const classes = useDashboardStyles();
    const [funerals, setFunerals] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState({isOpen: false});

    const load = () => UserService.getDeletedFunerals().then(
        (response) => setFunerals(response.data),
        (error) => {
            setFunerals([]);
            if (error.response?.status === 401) logOut(props);
            NotificationManager.error('Kôš sa nepodarilo načítať.', 'Chyba', 5000);
        }
    );

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const run = (request, funeralId, successMessage) => {
        setConfirmDialog({...confirmDialog, isOpen: false});
        request.then(() => {
            setFunerals((current) => current.filter((funeral) => funeral._id !== funeralId));
            NotificationManager.success(successMessage, 'Hotovo', 5000);
        }).catch(() => NotificationManager.error('Operácia sa nepodarila.', 'Chyba', 5000));
    };

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper}>
                <Title>Kôš</Title>
                {funerals === null ? (
                    <div className={classes.emptyState}>Načítava sa…</div>
                ) : funerals.length === 0 ? (
                    <div className={classes.emptyState}>Kôš je prázdny.</div>
                ) : (
                    <TableContainer>
                    <Table aria-label="Vymazané pohreby">
                        <TableHead>
                            <TableRow>
                                <TableCell>Zosnulý</TableCell>
                                <TableCell>Dátum úmrtia</TableCell>
                                <TableCell>Vymazané</TableCell>
                                <TableCell align="right">Akcie</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {funerals.map((funeral) => (
                                <TableRow key={funeral._id}>
                                    <TableCell><strong>{funeral.deceased}</strong></TableCell>
                                    <TableCell><Time value={funeral.d_death} format="DD.MM.YYYY HH:mm"/></TableCell>
                                    <TableCell><Time value={funeral.deletedAt} format="DD.MM.YYYY HH:mm"/></TableCell>
                                    <TableCell align="right">
                                        <Tooltip title="Obnoviť pohreb">
                                            <IconButton aria-label={`Obnoviť pohreb ${funeral.deceased}`} onClick={() => setConfirmDialog({
                                                isOpen: true,
                                                title: 'Obnoviť tento pohreb?',
                                                subTitle: 'Pohreb sa vráti do zoznamu.',
                                                onConfirm: () => run(UserService.restoreFuneral(funeral._id), funeral._id, 'Pohreb bol obnovený.')
                                            })}>
                                                <RestoreFromTrashIcon/>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Natrvalo odstrániť">
                                            <IconButton aria-label={`Natrvalo odstrániť pohreb ${funeral.deceased}`} color="secondary" onClick={() => setConfirmDialog({
                                                isOpen: true,
                                                title: 'Natrvalo odstrániť tento pohreb?',
                                                subTitle: 'Túto operáciu nie je možné vrátiť.',
                                                onConfirm: () => run(UserService.permanentlyDeleteFuneral(funeral._id), funeral._id, 'Pohreb bol natrvalo odstránený.')
                                            })}>
                                                <DeleteForeverIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    </TableContainer>
                )}
            </Paper>
            <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} icon={<DeleteForeverIcon/>}/>
        </Container>
    );
}
